import * as Icons from "lucide-react";

export const IconTile = ({ icon, title, desc, color = "#D81B60", testId, size = "md", center = false }) => {
  const Icon = Icons[icon] || Icons.Circle;
  const isLg = size === "lg";
  return (
    <div data-testid={testId} className={`h-full ${center ? "text-center" : ""}`}>
      <div
        className={`${isLg ? "w-16 h-16" : "w-12 h-12"} rounded-2xl flex items-center justify-center mb-4 ${center ? "mx-auto" : ""}`}
        style={{ backgroundColor: `${color}18` }}
      >
        <Icon size={isLg ? 28 : 22} style={{ color }} strokeWidth={1.75} />
      </div>
      {title && <h4 className={isLg ? "text-xl font-bold mb-2" : "text-lg font-bold mb-1.5"}>{title}</h4>}
      {desc && <p className="text-sm text-gray-500 leading-relaxed">{desc}</p>}
    </div>
  );
};
